import * as Sentry from '@sentry/react';
import { isProduction } from '../../config';

/**
 * Initialize Sentry error monitoring.
 *
 * Only runs for actual production builds (`react-scripts build` sets
 * NODE_ENV=production) deployed against the production stage
 * (REACT_APP_STAGE=PROD). This keeps local `npm start` sessions and dev
 * deployments out of the production Sentry project.
 */
export const initSentry = (): void => {
  if (process.env.NODE_ENV !== 'production' || !isProduction) {
    return;
  }

  Sentry.init({
    dsn: 'https://60ed2eb09914d94492c5ad0ee6126700@o4504242163613696.ingest.us.sentry.io/4511620102815744',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Performance monitoring
    tracesSampleRate: 1.0,
    // Session replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1,
    // Noise already swallowed by the global error listener in index.tsx; keep
    // it out of Sentry too.
    ignoreErrors: [
      'ResizeObserver loop completed with undelivered notifications.',
      'ResizeObserver loop limit exceeded',
    ],
  });
};
